var _path, _circle;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoveDownIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6464 18.3536C11.8417 18.5488 12.1583 18.5488 12.3536 18.3536L15.5355 15.1716C15.7308 14.9763 15.7308 14.6597 15.5355 14.4645C15.3403 14.2692 15.0237 14.2692 14.8284 14.4645L12 17.2929L9.17157 14.4645C8.97631 14.2692 8.65973 14.2692 8.46447 14.4645C8.2692 14.6597 8.2692 14.9763 8.46447 15.1716L11.6464 18.3536ZM11.5 6L11.5 18L12.5 18L12.5 6L11.5 6Z",
    fill: "currentColor"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5,
    transform: "rotate(-180 12 12)",
    stroke: "currentColor"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveDownIcon);
export default __webpack_public_path__ + "static/media/move-down-icon.560ece7b.svg";
export { ForwardRef as ReactComponent };